import { render } from "./TheUserOrders.vue?vue&type=template&id=78bef969&lang=pug"
import script from "./TheUserOrders.vue?vue&type=script&lang=js"
export * from "./TheUserOrders.vue?vue&type=script&lang=js"

import exportComponent from "/builds/chiedocover/chiedohome.com/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__